import data from 'basic-bootstrap'
import { prop, values, sortBy, toLower, when, pipe } from 'ramda'
import { createSelector } from 'reselect'
import selectorBuilder from '@/models/selector-builder'
import { isTruthy } from '@/utils'

const formatData = when(isTruthy, pipe(values, sortBy(pipe(prop('name'), toLower))))
const featuresSelector = createSelector(prop('unit_features'), formatData)

const utilitiesSelector = createSelector(prop('utilities'), formatData)

// Since objects with int keys are always sorted
// numerically, we need to sort by name with common banks at top.
// Then we can use bank_id as a string key so JS will leave insertion order.
const commonBanks = ['rbc', 'td', 'scotiabank', 'bmo', 'cibc']
const formatBanks = banks => {
  const list = Object.values(banks)
  const sorted = list.sort((a, b) => {
    if (a.txt_id === b.txt_id) return 0
    const aCommon = commonBanks.indexOf(a.txt_id) >= 0
    const bCommon = commonBanks.indexOf(b.txt_id) >= 0
    if (aCommon && bCommon) return 0
    if (aCommon) return -1
    if (bCommon) return 1
    const aName = a.name
    const bName = b.name
    if (aName > bName) return 1
    if (aName < bName) return -1
    return 0
  })
  const blob = sorted.reduce((acc, next) => ({ ...acc, [`bank_${next.id}`]: next }), {})
  return blob
}

const formatInitialData = data => {
  const { financial_institutions, ...rest } = data
  const banks = formatBanks(financial_institutions)
  return { ...rest, financial_institutions: banks }
}

const basic = {
  state: formatInitialData(data),
  selectors: selectorBuilder(slice => ({
    features() {
      return slice(featuresSelector)
    },
    utilities() {
      return slice(utilitiesSelector)
    }
  }))
}

export default basic
